import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import TaskCompletionSteps from './TaskCompletionSteps';
import { project_template_task_root } from  '../../../dao/TasksDAO';
import { task_complete } from  '../../../dao/TasksDAO';
import DataSource from '../../../dao/DataSource/DataSource';

import { getCompletionStepUserPermissions } from '../../../helpers/permissions/CompletionStepPermissionsUtil';

import './TaskCompletionStepsContainer.scss';
import Metadata from '../../../helpers/metadata/Metadata';

/*
const taskDescriptor = {
  task: {
    completion_criteria: {
      attachments: {
        additionalFields: ["upload", "photo_longitude", "photo_latitude", "photo_taken_at"],
        conversions: {},
        user: {} 
      } ,
      comments: { user: {additionalFields: ["profile_image"] }},
      event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} },
      form_fields: {}
    },
    reference_documents: {},
    user_task_assignments: {
      user: { additionalFields: ["profile_image"], 
        companies: {}
      }
    },
    build_owners: { companies: {} },
    inventory_items: {  inventory: {} },
    event_histories: { activity: {}, activity_sub_type: {}, user_who_performed_action: {} }
  }
}
*/

export class TaskCompletionStepsContainer extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = { 
      userStepPermissions: new Set(),
      isLocationEnabled: false,
    };
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.currentUserRoleName = currentRole ? currentRole.name : null;
    this.determineUserStepPermissions = this.determineUserStepPermissions.bind(this);
    this.checkLocationStatus = this.checkLocationStatus.bind(this);
  }

  async handleTaskUpdate(task, action, acData) {
    if (task) {
      this.setState({ task });
      this.determineUserStepPermissions(task);
    }
  }

  componentDidMount() {
    if (this.props.task) {
      this.taskDataSource = new DataSource('Task', this.props.task.id, (this.props.project || this.props.userProject) ? task_complete : project_template_task_root, this.handleTaskUpdate);
      this.taskDataSource.get();
    } 
    this.locationCheckInterval = setInterval(this.checkLocationStatus, 5000);
  }

  componentWillUnmount() {
    if (this.taskDataSource) {
      this.taskDataSource.release();
      this.taskDataSource = null;
    }
    clearInterval(this.locationCheckInterval);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.task || !this.props.task || prevProps.task.id != this.props.task.id) {
      if (this.taskDataSource) {
        this.taskDataSource.release();
      }
      this.taskDataSource = new DataSource('Task', this.props.task.id, this.props.project ? task_complete : project_template_task_root, this.handleTaskUpdate);
      this.taskDataSource.get();
    }
  }

  checkLocationStatus() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        () => {
          if (!this.state.isLocationEnabled) {
            this.setState({ isLocationEnabled: true });
            Metadata.start();
          }
        },
        () => {
          // error
          if (this.state.isLocationEnabled) {
            this.setState({ isLocationEnabled: false });
            Metadata.start();
          }
        }
      );
    } else {
      if (this.state.isLocationEnabled) {
        this.setState({ isLocationEnabled: false });
        Metadata.start();
      }
    }
  }

  determineUserStepPermissions() {
    const { 
      currentCompany,
      currentUser, 
      isBuildOwner, 
      userProject,
      project,
      projectTemplate,
    } = this.props;
      
    if (!currentCompany || !currentUser) {
      return null;
    }

    const task = this.state.task;
    
    const stepPermissions = getCompletionStepUserPermissions({
      currentCompany,
      currentUser, 
      isBuildOwner, 
      project: project ? project : userProject,
      task, 
      view: projectTemplate ? 'projectTemplates' : task ? 'tasks' : (project || userProject) ? 'projects' : 'tasks',
      completionStep: null,
      isVendor: currentUser.isVendorUser,
    });

    // only update state if stepPermissions have changed (avoid call stack overflow)
    if (this.state.userStepPermissions.size != stepPermissions.size && stepPermissions.size) {
      this.setState({ userStepPermissions: stepPermissions });
    }
    else {
      for (let existingPermission of this.state.userStepPermissions) {
        if (!stepPermissions.has(existingPermission)) {
          this.setState({ userStepPermissions: stepPermissions });
        }
      }
    }    
  }

  handleCompletionStepUpdate(updatedTask) {
    if (this.props.handleCompletionStepUpdate) {
      this.props.handleCompletionStepUpdate(updatedTask);
    }
  }

  render() {
    const { 
      project,
      projectTemplate,
    } = this.props;
    
    if (!this.state.task) {
      return null;
    }
    let completionSteps = (
      <TaskCompletionSteps 
        task={this.state.task} 
        editing={this.props.editing} 
        project={project}
        projectTemplate={projectTemplate}
        userProject={this.props.userProject} 
        build={this.props.build} 
        pmCanEdit={this.props.pmCanEdit}
        isBuildOwner={this.props.isBuildOwner}
        buildOwnerEditing={this.props.buildOwnerEditing}
        userStepPermissions={this.state.userStepPermissions}
        handleUpdate={this.handleCompletionStepUpdate}
        view={this.props.view}
      />
    );

    return (
      <div className="shared-task-detail">
        {completionSteps}
      </div>);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users ? state.new_users.currentUser : null,
    permissions: state.new_users.permissions,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(TaskCompletionStepsContainer);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskCompletionStepsContainer/index.js